import { t } from 'i18next';
import moment from 'moment';
import styled from 'styled-components';
import { CommonFlex, CommonText } from 'styledComponents/common';

import tickIcon from '../../../assets/img/Sidebar/clock-in.svg';

const TimeDurationContainer = styled.div`
  width: 100%;
  margin-top: 2px;
  font-size: 12px;
  padding: 10px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  text-align: center;
  background-color: #e6dbd7;
`;

const TimeDuration = ({ startDate, startTime, endDate, endTime }) => {
  const tempStartTime = moment(startTime, 'HH:mm:ss');
  const startDateTime = moment(startDate).set({
    hour: tempStartTime.hour(),
    minute: tempStartTime.minute(),
    second: tempStartTime.second(),
  });

  // Combine end date and time
  const endDateTime = moment(endDate.format('YYYY-MM-DD')).set({
    hour: moment(endTime, 'HH:mm:ss').hour(),
    minute: moment(endTime, 'HH:mm:ss').minute(),
    second: moment(endTime, 'HH:mm:ss').second(),
  });

  // Calculate the difference in milliseconds
  const timeDiffInMills = endDateTime.diff(startDateTime);

  // Convert milliseconds to desired time units
  const duration = moment.duration(timeDiffInMills);

  // Get the duration in hours, minutes, and seconds
  let hours = Math.floor(duration.asMilliseconds() / (1000 * 60 * 60));
  let minutes = duration.minutes() + Math.ceil(duration.seconds() / 60);
  if (minutes === 60) {
    hours = hours + 1;
    minutes = 0;
  }

  return (
    <TimeDurationContainer>
      <CommonFlex gap="10px" alignItems="center">
        <img src={tickIcon} alt="" style={{ height: '15px', width: '15px' }} />
        <CommonText fontWeight="500" fontSize="13px" name>
          {t('task_duration')} :{' '}
          {minutes < 0 || hours < 0 ? (
            <span style={{ color: '#FF0000' }}>
              - {hours < 0 ? hours * -1 + 'H ' : ''} {minutes * -1 + 'Min'}
            </span>
          ) : (
            <>
              {hours > 0 ? hours + 'H ' : ''} {minutes + 'Min'}
            </>
          )}
        </CommonText>
      </CommonFlex>
    </TimeDurationContainer>
  );
};

export default TimeDuration;
